import BlankLayout from "../components/BlankLayout"
import DefaultLayout from '../components/DefaultLayout';
import HeaderLayout from '../components/HeaderLayout';
import { routes } from './routes';

const finalRoutes = routes.map((route) => {
    return {
        ...route,
        element: route.layout === 'blank' ? <BlankLayout>{route.element}</BlankLayout> : route.layout === 'header' ? <HeaderLayout>{route.element}</HeaderLayout> : <DefaultLayout>{route.element}</DefaultLayout>,
    };
});

const router = finalRoutes

export default router;
